import React from 'react';

import { get } from 'lodash';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from '@gogame/components';
import { withFormFieldGroupFormField } from '@gogame/form';

import EventGroupTable from './EventGroupTable';

const getSummary = (arr) => {
  const dataSet = new Set();
  arr.forEach(({ channels }) => {
    channels.forEach(({ name, checked }) => {
      const lowerCaseName = name.toLowerCase();

      if (checked) {
        dataSet.add(lowerCaseName);
      }
    });
  });

  let summary = '';
  dataSet.forEach((value) => {
    if (!summary.length) {
      summary = 'by ' + value;
    } else {
      summary = summary + ', ' + value;
    }
  });

  if (!summary) {
    summary = 'disabled';
  }
  return summary;
};
const NotificationSettingsItem = withFormFieldGroupFormField()(({
  errors,
  group,
  name,
}) => {
  const error = get(errors, `${name}.events`);

  return (
    <Accordion>
      <AccordionSummary>
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          width={'100%'}
        >
          <Typography
            variant={'subtitle1'}
            color={error && 'error'}
            sx={{ fontWeight: 400 }}
          >
            {group.name}
          </Typography>
          <Typography color={'textSecondary'}>
            {getSummary(group.events)}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <EventGroupTable
          data={group.events}
          name={`events`}
          eventError={error}
          errorName={`${name}.events`}
        />
      </AccordionDetails>
    </Accordion>
  );
});

export default NotificationSettingsItem;
